import parse from 'date-fns/parse';
import getHours from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import { generateTimeSlots, getTime } from './businessHour';

/** Example default: Mon–Fri 18:00–08:00 (overnight), Sat–Sun all day */
export const defaultBotScheduleSlots = () =>
  [0, 1, 2, 3, 4, 5, 6].map(day => {
    if (day === 0 || day === 6) {
      return {
        day,
        enabled: true,
        openAllDay: true,
        from: '12:00 AM',
        to: '11:59 PM',
        valid: true,
      };
    }
    return {
      day,
      enabled: true,
      openAllDay: false,
      from: '06:00 PM',
      to: '08:00 AM',
      valid: true,
    };
  });

export const emptyBotScheduleSlots = () =>
  [0, 1, 2, 3, 4, 5, 6].map(day => ({
    day,
    enabled: false,
    openAllDay: false,
    from: '',
    to: '',
    valid: false,
  }));

export const parseBotSchedule = schedule => {
  if (!Array.isArray(schedule) || !schedule.length) {
    return emptyBotScheduleSlots();
  }

  const byDay = Object.fromEntries(
    schedule.map(slot => [Number(slot.day_of_week), slot])
  );

  return [0, 1, 2, 3, 4, 5, 6].map(day => {
    const slot = byDay[day];
    if (!slot || !slot.enabled) {
      return {
        day,
        enabled: false,
        openAllDay: false,
        from: '',
        to: '',
        valid: false,
      };
    }
    if (slot.open_all_day) {
      return {
        day,
        enabled: true,
        openAllDay: true,
        from: '12:00 AM',
        to: '11:59 PM',
        valid: true,
      };
    }
    const from = getTime(
      Number(slot.open_hour),
      Number(slot.open_minutes || 0)
    );
    const to = getTime(
      Number(slot.close_hour),
      Number(slot.close_minutes || 0)
    );
    return {
      day,
      enabled: true,
      openAllDay: false,
      from,
      to,
      valid: Boolean(from && to),
    };
  });
};

export const transformBotSchedule = timeSlots =>
  timeSlots.map(slot => {
    if (!slot.enabled) {
      return {
        day_of_week: slot.day,
        enabled: false,
        open_all_day: false,
        open_hour: null,
        open_minutes: 0,
        close_hour: null,
        close_minutes: 0,
      };
    }
    if (slot.openAllDay) {
      return {
        day_of_week: slot.day,
        enabled: true,
        open_all_day: true,
        open_hour: 0,
        open_minutes: 0,
        close_hour: 23,
        close_minutes: 59,
      };
    }
    const fromDate = parse(slot.from, 'hh:mm a', new Date());
    const toDate = parse(slot.to, 'hh:mm a', new Date());
    return {
      day_of_week: slot.day,
      enabled: true,
      open_all_day: false,
      open_hour: getHours(fromDate),
      open_minutes: getMinutes(fromDate),
      close_hour: getHours(toDate),
      close_minutes: getMinutes(toDate),
    };
  });

export const botScheduleHasError = timeSlots =>
  timeSlots.some(slot => slot.enabled && !slot.openAllDay && !slot.valid);

export { generateTimeSlots };
